/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Popconfirm } from 'antd';
import getUserRole from '../../../../utils/localeStorage/getUserRole';
import PropTypes from 'prop-types';

const { TextArea } = Input;
const PlanRow = ({
  index,
  application,
  disabled,
  total,
  agreementData,
  formRef,
}) => {
  const [baseDocuments, setBaseDocuments] = useState([])
  const [documents, setDocuments] = useState(
    agreementData?.[`etap${index}_documents`]
      ? JSON.parse(agreementData[`etap${index}_documents`])
      : [{}]
  );
  const [newDocumentName, setNewDocumentName] = useState('');

  useEffect(() => {
    switch (total) {
      case 1:
        switch (index) {
          case 1:
            setBaseDocuments([
              {
                label: '– Финансовый отчет',
                deletable: false,
              },
              {
                label:
                  '– Итоговый отчет о реализации научно-практического проекта в сфере медицины',
                deletable: false,
              },
              {
                label: '– Акт сдачи-приемки выполненных по Проекту работ',
                deletable: false,
              },
            ]);
            break;
        }
        break;
      case 2:
        switch (index) {
          case 1:
            setBaseDocuments([
              {
                label: '– Финансовый отчет',
                deletable: false,
              },
              {
                label:
                  '– Форма мониторинга достижения значений результатов предоставления гранта',
                deletable: false,
              },
              {
                label: '– Акт сверки',
                deletable: false,
              },
            ]);
            break;
          case 2:
            setBaseDocuments([
              {
                label: '– Финансовый отчет',
                deletable: false,
              },
              {
                label:
                  '– Итоговый отчет о реализации научно-практического проекта в сфере медицины',
                deletable: false,
              },
              {
                label: '– Акт сдачи-приемки выполненных по Проекту работ',
                deletable: false,
              },
            ]);
            break;
        }
        break;
      case 3:
        switch (index) {
          case 1:
            setBaseDocuments([
              {
                label: '– Финансовый отчет',
                deletable: false,
              },
              {
                label:
                  '– Форма мониторинга достижения значений результатов предоставления гранта',
                deletable: false,
              },
              {
                label: '– Акт сверки',
                deletable: false,
              },
            ]);
            break;
          case 2:
            setBaseDocuments([
              {
                label: '– Финансовый отчет',
                deletable: false,
              },
              {
                label:
                  '– Форма мониторинга достижения значений результатов предоставления гранта',
                deletable: false,
              },
              {
                label: '– Акт сверки',
                deletable: false,
              },
            ]);
            break;
          case 3:
            setBaseDocuments([
              {
                label: '– Финансовый отчет',
                deletable: false,
              },
              {
                label:
                  '– Итоговый отчет о реализации научно-практического проекта в сфере медицины',
                deletable: false,
              },
              {
                label: '– Акт сдачи-приемки выполненных по Проекту работ',
                deletable: false,
              },
            ]);
            break;
        }
        break;
    }
  }, []);

  const handleAddDocument = () => {
    if (newDocumentName.length < 1) return;

    setDocuments([
      ...documents,
      {
        label: `– ${newDocumentName}\n`,
        deletable: true,
      },
    ]);
    setNewDocumentName('');
  };

  const handleDeleteDocument = (label) => {
    let documentsClone = structuredClone(documents);

    documentsClone = documentsClone.filter((el) => el.label !== label);

    setDocuments(documentsClone);
  };

  const handleEditDocument = (label) => {
    let documentsClone = structuredClone(documents);

    const documentToEdit = documentsClone.find((el) => el.label === label);

    documentToEdit.label = `– ${newDocumentName}\n`;

    setDocuments(documentsClone);
    setNewDocumentName('');
  };

  useEffect(() => {
    const fields = formRef.current.getFieldsValue();

    formRef.current.setFieldsValue({
      ...fields,
      [`etap${index}_documents`]: JSON.stringify(documents),
    });
  }, [documents]);

  const dates = () => {
    switch (index) {
      case 1:
        return `
          С даты заключения Соглашения до 20.12.2025 года (включительно)
        `;
      case 2:
        return `С даты предоставления Грантополучателем надлежащим образом оформленных Финансового отчета и Акта сверки за 1 (Первый) этап реализации Проекта до 20.12.2026 г. (включительно)`;

      case 3:
        return `
         С даты предоставления Грантополучателем надлежащим образом оформленных Финансового отчета и Акта сверки за 2 (Второй) этап реализации Проекта до 20.12.2027 г. (включительно)
      `;
    }
  };

  return (
    <div className="common-table-row">
      <div
        className="common-table-row-cell"
        style={{ width: '4%', textAlign: 'center' }}
      >
        {index}
      </div>
      <div
        className="common-table-row-cell"
        style={{ width: '16%', textAlign: 'center', fontWeight: 'bold' }}
      >{`Этап ${index}`}</div>
      <Form.Item
        style={{ width: '16%' }}
        name={`etap${index}_soderzanie`}
        initialValue={
          application[`step${index}PlanWorkDescription`]
        }
      >
        <TextArea autoSize />
      </Form.Item>
      <div
        className="common-table-row-cell"
        style={{ width: '16%', textAlign: 'center' }}
      >
        {dates()}
      </div>
      <Form.Item
        style={{ width: '16%' }}
        name={`etap${index}_result`}
        initialValue={
          application[`step${index}PlanWorkResult`]
        }
      >
        <TextArea autoSize />
      </Form.Item>
      <div
        className="common-table-row-cell"
        style={{ width: '16%', textAlign: 'center' }}
      >
        {baseDocuments.filter(el => el.label).map((el) => (
          <div>
            <span>{el.label.replace('\n', '')}</span>
            {el.deletable && (
              <Popconfirm
                title="Удалить документ?"
                onConfirm={() => handleDeleteDocument(el.label)}
                okText="Да"
                cancelText="Нет"
              >
                <Button style={{ marginLeft: 4 }} size="small" type="danger">
                  Удалить
                </Button>
              </Popconfirm>
            )}
          </div>
        ))}
        {documents.filter(el => el.label).map((el) => (
          <div>
            <span>{el.label.replace('\n', '')}</span>
            {el.deletable && (
              <div>
                <Popconfirm
                  title={
                    <Input
                      value={newDocumentName}
                      onChange={(e) => setNewDocumentName(e.target.value)}
                      label="Название документа"
                      placeholder="Название документа"
                    />
                  }
                  icon={<></>}
                  okText="Сохранить"
                  onOpenChange={() => setNewDocumentName(el.label.replace('\n', '').replace('– ', ''))}
                  onConfirm={() => handleEditDocument(el.label)}
                >
                  <Button style={{ marginLeft: 4 }} size="small" type="primary">
                    Редактировать
                  </Button>
                </Popconfirm>

                <Popconfirm
                  title="Удалить документ?"
                  onConfirm={() => handleDeleteDocument(el.label)}
                  okText="Да"
                  cancelText="Нет"
                >
                  <Button style={{ marginLeft: 4 }} size="small" type="danger">
                    Удалить
                  </Button>
                </Popconfirm>
              </div>
            )}
          </div>
        ))}
        <Popconfirm
          title={
            <Input
              value={newDocumentName}
              onChange={(e) => setNewDocumentName(e.target.value)}
              label="Название документа"
              placeholder="Название документа"
            />
          }
          icon={<></>}
          okText="Добавить"
          onConfirm={handleAddDocument}
        >
          <Button
            style={{ marginTop: 10 }}
            type="primary"
            className="ant-btn ant-btn-primary"
          >
            Добавить документ
          </Button>
        </Popconfirm>
        <Form.Item
          hidden
          name={`etap${index}_documents`}
          initialValue={agreementData?.[`etap${index}_documents`]}
        >
          <Input />
        </Form.Item>
      </div>
      <Form.Item
        style={{ width: '16%' }}
        name={`etap${index}_comment`}
        initialValue={agreementData?.[`etap${index}_comment`]}
      >
        <TextArea
          autoSize
          style={{ color: 'red' }}
          disabled={getUserRole() !== 'bigAdmin'}
        />
      </Form.Item>
    </div>
  );
};

PlanRow.propTypes = {
  application: PropTypes.shape().isRequired,
  agreementData: PropTypes.shape().isRequired,
  total: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  // updateOriginalObject: PropTypes.func.isRequired,
  formRef: PropTypes.shape().isRequired,
};

export default PlanRow;
